module.exports = __webpack_public_path__ + "img/arrow-up.3432695d.svg";